export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/573232209100"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escribir por WhatsApp"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3"
    >
      <span className="hidden sm:block max-w-0 overflow-hidden whitespace-nowrap group-hover:max-w-xs transition-all duration-300 ease-in-out">
        <span className="inline-block px-4 py-2 rounded-full bg-background-50 border border-background-200 text-foreground-900 text-sm font-semibold">
          ¿Hablamos?
        </span>
      </span>
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors">
        <span className="absolute inset-0 rounded-full bg-accent-500 animate-ping opacity-30" />
        <i className="ri-whatsapp-line text-2xl md:text-3xl relative w-7 h-7 md:w-8 md:h-8 flex items-center justify-center" />
      </span>
    </a>
  );
}